import { motion } from "framer-motion";
import { MoonStar, CloudFog } from "lucide-react";

const stat = (value, label) => ({ value, label });
const STATS = [
  stat("2019", "Founded in Kreuzberg, Berlin"),
  stat("1M+", "YouTube Subscribers"),
  stat("200M+", "Cumulative Views"),
  stat("1000s", "Sets Broadcast"),
];

export const AboutHor = () => {
  return (
    <section className="relative bg-black py-24 sm:py-32 px-4 sm:px-6 overflow-hidden" data-testid="about-hor-section">
      <div className="absolute inset-0 tile-grid-tight opacity-[0.15]" />
      <motion.div
        animate={{ x: [0, 30, 0], opacity: [0.04, 0.08, 0.04] }}
        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-0 right-0 text-white"
      >
        <CloudFog size={200} strokeWidth={0.6} />
      </motion.div>
      <div className="relative max-w-5xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-acid mb-6 flex items-center gap-2"
        >
          <MoonStar size={14} className="text-blood" /> The Platform
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-extrabold uppercase text-3xl sm:text-5xl tracking-tight leading-[1.05] max-w-3xl"
        >
          A glass booth in Berlin. White tiles. One static camera. No crowd —
          just the sound.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-8 max-w-2xl text-base sm:text-lg text-zinc-400 leading-relaxed font-body"
        >
          That's HÖR — the Kreuzberg streaming platform that redefined how the
          world watches underground electronic music. What started as a raw,
          DIY broadcast became one of the most influential forces in techno
          culture, turning unknown DJs into global names from behind a single
          wall of bathroom tile. This Halloween, HÖR steps out of the booth
          and into India for one night only.
        </motion.p>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-6 border-t border-white/10 pt-10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`hor-stat-${i}`}
            >
              <p className="font-display font-extrabold text-3xl sm:text-4xl text-acid">
                {s.value}
              </p>
              <p className="mt-2 font-mono text-[11px] uppercase tracking-wider text-zinc-500">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
